export const EXPORT_HISTORY_LOAD = 'EXPORT_HISTORY_LOAD'
export const EXPORT_HISTORY_LOAD_PENDING = 'EXPORT_HISTORY_LOAD_PENDING'
export const EXPORT_HISTORY_LOAD_FULFILLED = 'EXPORT_HISTORY_LOAD_FULFILLED'
export const EXPORT_HISTORY_LOAD_REJECTED = 'EXPORT_HISTORY_LOAD_REJECTED'

export const EXPORT_REPORT_FILE = 'EXPORT_REPORT_FILE'
export const EXPORT_REPORT_FILE_PENDING = 'EXPORT_REPORT_FILE_PENDING'
export const EXPORT_REPORT_FILE_FULFILLED = 'EXPORT_REPORT_FILE_FULFILLED'
export const EXPORT_REPORT_FILE_REJECTED = 'EXPORT_REPORT_FILE_REJECTED'
